import { render, staticRenderFns } from "./mySelect.vue?vue&type=template&id=674087a0"
import script from "./mySelect.vue?vue&type=script&lang=js"
export * from "./mySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports